import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import ModalContainer from '@components/modals/ModalContainer';
import { toastError, toastSuccess } from '@components/Toast';

import {
	CloseButton,
	ModalBody,
	ModalHeader,
	ModalTitle
} from '@features/trend-research/components/common/Modal';
import Images from '@features/trend-research/components/common/ProductModal/Images';
import ProductDescription from '@features/trend-research/components/common/ProductModal/ProductDescription';
import SimilarProduct from '@features/trend-research/components/common/ProductModal/SimilarProducts';
import { capitalizeFirstLetter, sourceType } from '@features/trend-research/utils/utils';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { getSingleProduct, updateProductById } from '@services/trendResearch';

const ProductModal = ({ onClose, id, typeOfSource }) => {
	const dispatch = useDispatch();
	const location = useLocation();
	const { source } = location?.state || {};

	const [singleProduct, setSingleProduct] = useState(null);

	const fetchSingleProducts = async () => {
		try {
			dispatch(openLoader());
			const response = await getSingleProduct(sourceType[typeOfSource || source], id);
			setSingleProduct(response);
			if (!response) {
				dispatch(closeLoader());
				return;
			}

			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};
	useEffect(() => {
		fetchSingleProducts();
	}, [id]);

	const handleClose = () => {
		setSingleProduct(null); // Reset singleProduct state
		onClose(); // Call the parent component's onClose function
	};

	const markAsError = async (value) => {
		try {
			dispatch(openLoader());
			const postData = {
				isError: value
			};
			const response = await updateProductById(sourceType[typeOfSource || source], id, postData);
			if (response.success) {
				toastSuccess(response.message);
			} else {
				toastError('Something went wrong!');
			}

			fetchSingleProducts();
			if (!response) {
				dispatch(closeLoader());
				return;
			}

			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	return (
		<ModalContainer
			onCloseModal={handleClose}
			className="trend-product-details-modal trend-data-container"
		>
			<div className="popup-wrapper">
				<div className="common-popup category-pom-modal trend-product-details-modal">
					<ModalHeader>
						<ModalTitle title={capitalizeFirstLetter(singleProduct?.name)} />
						<CloseButton onClick={handleClose} />
					</ModalHeader>

					<ModalBody className="product-slider-body  scroll-y-label shadow-1dp">
						<div className="product-slider-section trend-slide-section">
							<div className="product-information d-flex justify-content-between align-items-start">
								<Images
									imageUrl={singleProduct?.imageUrl}
									imageList={singleProduct?.allImageUrls}
								/>
								{singleProduct && (
									<ProductDescription
										singleProduct={singleProduct}
										markAsError={markAsError}
									/>
								)}
							</div>
						</div>
						{singleProduct && (
							<SimilarProduct singleProduct={singleProduct} typeOfSource={typeOfSource} />
						)}
					</ModalBody>
				</div>
			</div>
		</ModalContainer>
	);
};

export default ProductModal;
